import React, { ReactElement } from "react";
import LayoutWithDots from "./Components/LayoutWithDots";
import ChambersAndPartnersLogo from "../../assets/images&icons/ChambersAndPartnersLogo.png";
import CompassLegalMarketingLogo from "../../assets/images&icons/CompassLegalMarketingLogo.png";
import PostEventbanner from "../../assets/images&icons/post-event-banner.jpg";
import NatashaHeadshot from "../../assets/images&icons/natasha-headshot.jpg";
import JamieHeadshot from "../../assets/images&icons/jamie-headshot.png";
import WhereToStartThumbnail from "../../assets/images&icons/where-to-start-thumbnail.png";
import ProvenStrategiesThumbnail from "../../assets/images&icons/mastering-chambers-thumbnail.png";

import PostEventVertical from "../../assets/images&icons/post-event-banner-vertical.jpg";
import ChecklistResourcesThumbnail from "../../assets/images&icons/checklist-and-resources-thumbnail.png";

export default function WSGMarketingWorkshop(): ReactElement {

  const handleHorizontalClick = (e: React.MouseEvent<HTMLDivElement>) => {
    const xPosition = e.nativeEvent.offsetX;
    const totalWidth = e.currentTarget.clientWidth;
    const middleWidth = totalWidth / 2;

    let email = "";
    
    if (xPosition > middleWidth) {
      email = "natasha.urban@compasslegalmarketing.com";
    } else {
      email = "samuel.crawford@chambers.com";
    }
    window.open(`mailto:${email}`, "_blank");
  };
  
  const handleVerticalClick = (e: React.MouseEvent<HTMLDivElement>) => {
    const yPosition = e.nativeEvent.offsetY; 
    const totalHeight = e.currentTarget.clientHeight;
    const middleHeight = totalHeight / 2;
    
    let email = "";
    if (yPosition > middleHeight) {
      email = "natasha.urban@compasslegalmarketing.com";
    } else {
      email = "samuel.crawford@chambers.com";
    }
    window.open(`mailto:${email}`, "_blank");
  };

  return (
    <>
      <LayoutWithDots
        subTitle="WSG Marketing Workshop"
        subTitleText="Ranking Submissions Success Strategies"
      />
      <div className="bg-white w-full min-h-screen px-4 sm:px-6 md:px-7 py-6 md:py-12">
        <div className="bg-gray-50 pb-6 md:pb-8 rounded-t-3xl lg:rounded-t-[72px]">
          <div className="flex flex-col sm:flex-row items-center gap-6 md:gap-8 lg:gap-16 bg-dots-235383 px-4 sm:px-6 md:px-10 lg:px-14 pt-8 sm:pt-10 md:pt-12 pb-6 md:pb-8 rounded-t-3xl lg:rounded-t-[72px]">
            <div className="flex items-center gap-8">
              <div className="flex items-center">
                <img
                  src={ChambersAndPartnersLogo}
                  alt="Chambers & Partners"
                  className="h-16 md:h-24 lg:h-44 w-16 md:w-24 lg:w-44 min-w-[64px] max-w-[176px]"
                />
              </div>
            </div>
            <div className="flex flex-col gap-2 justify-center items-center sm:items-start self-end">
              <span className="text-center sm:text-left text-2xl sm:text-3xl md:text-4xl lg:text-5xl leading-normal font-bold text-white">
                Rise in the Rankings:
              </span>
              <span className="text-center sm:text-left text-2xl sm:text-3xl md:text-4xl lg:text-5xl leading-normal font-bold text-white">
                Your Chambers & Partners Success Playbook
              </span>
            </div>
          </div>
          <div className="bg-[#203b68] font-decimal text-white font-bold text-xl tracking-wide px-6 sm:px-8 md:px-12 py-1.5 pr-6 sm:pr-8 md:pr-10 inline-block [clip-path:polygon(0_0,100%_0,calc(100%-15px)_100%,0_100%)] mt-4 sm:mt-6 lg:mt-8">
            Session 1 &ndash; Webinar
          </div>
          <div className="bg-gray-50">
            <div className="pt-6 sm:pt-8 md:pt-12 pb-6 md:pb-8 flex flex-col gap-4">
              <div className="border-b border-primary pb-0 flex-shrink-0 mb-4 w-fit self-start">
                <h3 className="text-xl md:text-[24px] font-bold font-decimal text-gray-font leading-4 md:leading-5 mb-2 text-left px-4 md:px-8">
                  Webinar: Proven Strategies to Boost Your Legal Rankings
                </h3>
              </div>
              <div className="flex flex-col lg:flex-row items-stretch lg:items-start gap-6 lg:gap-12 justify-between">
                <div className="flex flex-col gap-4 px-4 md:px-8 text-lg md:text-xl text-gray-font font-normal font-roboto">
                  <p>
                    Building on the foundational session, this webinar focused
                    on how Chambers submissions are evaluated and the core
                    components researchers review during the rankings process.
                    The session provided practical guidance on structuring
                    submissions, selecting and presenting work highlights,
                    coordinating referee outreach, preparing attorneys for
                    interviews, and maintaining long-term consistency in
                    rankings strategy.
                  </p>
                  <p className="font-semibold">Takeaways:</p>
                  <ul className="list-disc list-outside pl-4">
                    <li>
                      Submissions require strategy and organization and content;
                      start early and manage the process deliberately.
                    </li>
                    <li>
                      Selecting referees that are responsive, high-value
                      contacts and allocating them strategically across lawyers
                      can directly impact rankings.
                    </li>
                    <li>
                      Proactive communication with referees and researchers
                      improves response rates and ensures submission is properly
                      considered.
                    </li>
                    <li>
                      Work highlights should be concise, compelling, and
                      jargon-free descriptions of the most impactful matters.
                    </li>
                    <li>
                      The department overview is a key differentiator and should
                      clearly articulate sophistication of work, and client
                      caliber.
                    </li>
                    <li>
                      Attorney interview preparation should include tailored
                      messaging, relevant matters, and market context to
                      reinforce the written submission.
                    </li>
                    <li>
                      Submission success requires a long-term, consistent
                      approach, with sustained quality submissions over multiple
                      years.
                    </li>
                  </ul>
                </div>
                <div className="flex flex-col gap-4 w-full lg:w-[300px] lg:min-w-[300px] lg:flex-shrink-0 px-4 md:px-8 lg:pl-0 lg:pr-14">
                  <div className="w-full aspect-video overflow-hidden rounded-lg">
                    <iframe
                      className="w-full h-full"
                      src="https://www.youtube-nocookie.com/embed/CfyghlUgRjE"
                      title="Chambers Success Strategies: Proven Strategies to Boost Your Legal Rankings"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                      allowFullScreen
                      loading="lazy"
                      referrerPolicy="strict-origin-when-cross-origin"
                    />
                  </div>
                  <a
                    href={`${process.env.PUBLIC_URL || ""}/documents/MasteringtheChambers%26PartnersSubmissionProcess.pdf`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="block w-full aspect-video overflow-hidden rounded-lg cursor-pointer hover:opacity-90 transition-opacity"
                  >
                    <img
                      src={ProvenStrategiesThumbnail}
                      alt="Webinar: Proven Strategies to Boost Your Legal Rankings - View PDF Presentation"
                      className="w-full h-full object-cover object-center"
                    />
                  </a>
                  <a
                    href={`${process.env.PUBLIC_URL || ""}/documents/ChambersChecklistTimeline.pdf`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="block w-full aspect-video overflow-hidden rounded-lg cursor-pointer hover:opacity-90 transition-opacity"
                  >
                    <img
                      src={ChecklistResourcesThumbnail}
                      alt="Chambers & Partners Checklist and Resources - View PDF"
                      className="w-full h-full object-cover object-center"
                    />
                  </a>
                </div>
              </div>
            </div>

            <div className="bg-[#203b68] text-white font-bold font-decimal text-xl tracking-wide px-6 sm:px-8 md:px-12 py-1.5 pr-6 sm:pr-8 md:pr-10 inline-block [clip-path:polygon(0_0,100%_0,calc(100%-15px)_100%,0_100%)]">
              Session 2 &ndash; Webinar
            </div>

            <div className="pt-6 sm:pt-8 md:pt-12 pb-6 md:pb-8 flex flex-col gap-4">
              <div className="border-b border-primary pb-0 flex-shrink-0 mb-4 w-fit self-start">
                <h3 className="text-xl md:text-[24px] font-bold text-gray-font leading-4 md:leading-5 mb-2 text-left font-decimal px-4 md:px-8">
                  Webinar: Where to Start the Ranking Submission Process
                </h3>
              </div>
              <div className="flex flex-col lg:flex-row items-stretch lg:items-start gap-6 lg:gap-12 justify-between">
                <div className="flex flex-col gap-4 px-4 md:px-8 text-lg md:text-xl text-gray-font font-normal">
                  <p>
                    This session provided a foundational overview of how
                    Chambers rankings are built and what firms should consider
                    before submitting for the first time. Participants gained a
                    structured framework for assessing readiness, identifying
                    appropriate categories, selecting impactful matters, and
                    understanding how researcher interactions influence
                    outcomes.
                  </p>
                  <p className="font-semibold">Takeaways:</p>
                  <ul className="list-disc list-outside pl-4">
                    <li>
                      The submission process is strategic and year-round,
                      requiring early planning, clear goals, and deliberate
                      category and lawyer selection.
                    </li>
                    <li>
                      Begin with disciplined pre-submission work—analyzing
                      current rankings, defining advancement objectives, and
                      aligning matter selection with those goals.
                    </li>
                    <li>
                      Work highlights should be recent, high-impact, and
                      outcome-focused, demonstrating complexity and measurable
                      client results in concise, plain language.
                    </li>
                    <li>
                      Selecting the right referees and proactively managing
                      communication significantly increases response rates and
                      influence.
                    </li>
                    <li>
                      Successful submissions are coordinated efforts across
                      drafting, review, and firm leadership.
                    </li>
                  </ul>
                </div>
                <div className="flex flex-col gap-4 w-full lg:w-[300px] lg:min-w-[300px] lg:flex-shrink-0 px-4 md:px-8 lg:pl-0 lg:pr-14">
                  <div className="w-full aspect-video overflow-hidden rounded-lg">
                    <iframe
                      className="w-full h-full"
                      src="https://www.youtube-nocookie.com/embed/9CaYkvFlqSQ"
                      title="Chambers Success Strategies: Where to Start the Rankings Submission Process"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                      allowFullScreen
                      loading="lazy"
                      referrerPolicy="strict-origin-when-cross-origin"
                    />
                  </div>
                  <a
                    href={`${process.env.PUBLIC_URL || ""}/documents/WheretoStarttheRankingsSubmissionProcess-Chambers%26PartnersPresentation.pdf`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="block w-full aspect-video overflow-hidden rounded-lg cursor-pointer hover:opacity-90 transition-opacity"
                  >
                    <img
                      src={WhereToStartThumbnail}
                      alt="Webinar: Where to Start the Rankings Submission Process - View PDF Presentation"
                      className="w-full h-full object-cover object-center"
                    />
                  </a>
                  <a
                    href={`${process.env.PUBLIC_URL || ""}/documents/ChambersChecklistTimeline.pdf`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="block w-full aspect-video overflow-hidden rounded-lg cursor-pointer hover:opacity-90 transition-opacity"
                  >
                    <img
                      src={ChecklistResourcesThumbnail}
                      alt="Chambers & Partners Checklist and Resources - View PDF"
                      className="w-full h-full object-cover object-center"
                    />
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div className="bg-white border border-gray-300 rounded-3xl p-4 m-2 sm:m-4">
            <img
              src={PostEventVertical}
              alt="Post Event Banner"
              className="w-full h-full rounded-2xl sm:rounded-3xl object-cover block lg:hidden cursor-pointer"
              onClick={handleVerticalClick}
              />
            <img
              src={PostEventbanner}
              alt="Post Event Banner"
              className="w-full h-full rounded-2xl sm:rounded-3xl object-cover hidden lg:block cursor-pointer"
              onClick={handleHorizontalClick}
              />
          </div>
          <div className="bg-white border border-gray-300 rounded-3xl p-4 sm:p-6 md:p-8 m-2 sm:m-4 items-center justify-center flex flex-col gap-6 md:gap-8">
            <p className="text-primary font-normal text-2xl sm:text-3xl font-decimal text-center">
              Program Experience
            </p>
            <div className="flex flex-col lg:flex-row gap-8 lg:gap-16 items-center">
              <div className="flex flex-col gap-4 w-full lg:w-1/2 justify-center items-center">
                <div className="flex flex-row gap-8 sm:gap-12 md:gap-20 justify-center items-end">
                  <div className="flex flex-col items-center gap-0">
                    <div className="w-28 h-28 md:w-40 md:h-40 rounded-full overflow-hidden flex-shrink-0">
                      <img
                        src={NatashaHeadshot}
                        alt="Natasha"
                        className="w-full h-full object-cover object-top"
                      />
                    </div>
                    <span className="text-secondary font-semibold text-base md:text-lg mt-2 text-center">
                      Natasha Urban
                    </span>
                    <span className="text-gray-font font-normal text-base md:text-lg text-center">
                      Senior Account Manager
                    </span>
                    <span className="text-gray-font font-normal text-base md:text-lg text-center">
                      Compass Legal Marketing
                    </span>
                  </div>
                  <div className="flex flex-col items-center gap-0">
                    <div className="w-28 h-28 md:w-40 md:h-40 rounded-full overflow-hidden flex-shrink-0">
                      <img
                        src={JamieHeadshot}
                        alt="Jamie"
                        className="w-full h-full object-cover object-top"
                      />
                    </div>
                    <span className="text-secondary font-semibold text-base md:text-lg mt-2 text-center">
                      Jamie Cotera
                    </span>
                    <span className="text-gray-font font-normal text-base md:text-lg text-center">
                      Co-Founder
                    </span>
                    <span className="text-gray-font font-normal text-base md:text-lg text-center">
                      Compass Legal Marketing
                    </span>
                  </div>
                </div>
              </div>
              <p className="text-gray-font font-normal text-base w-full lg:w-1/2 text-center px-4 md:text-xl">
                Compass Legal Marketing is a leading consultancy specializing in
                awards and rankings submissions. Compass provides expert
                guidance to law firms throughout the Chambers & Partners
                submission process, including best practices for structuring
                submissions, meeting requirements, understanding researcher
                expectations, and positioning firms for long-term success in
                competitive legal markets.
              </p>
            </div>
            <img
              src={CompassLegalMarketingLogo}
              alt="Compass Legal Marketing"
              className="w-32 sm:w-40 md:w-48 max-w-[200px] lg:w-1/3"
            />
          </div>
        </div>
      </div>
    </>
  );
}
